import { v, type Infer } from "convex/values";

export const dayOfWeekValidator = v.union(
  v.literal("monday"),
  v.literal("tuesday"),
  v.literal("wednesday"),
  v.literal("thursday"),
  v.literal("friday"),
  v.literal("saturday"),
  v.literal("sunday"),
);

export type DayOfWeek = Infer<typeof dayOfWeekValidator>;

export const DAYS_OF_WEEK = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const satisfies readonly DayOfWeek[];

export const dockHourEntryValidator = v.object({
  day: dayOfWeekValidator,
  opens: v.string(),
  closes: v.string(),
});

export type DockHourEntry = Infer<typeof dockHourEntryValidator>;

export const dockHoursValidator = v.array(dockHourEntryValidator);

export type DockHours = Infer<typeof dockHoursValidator>;

export function validateDockHoursTimeRanges(
  dockHours: DockHours | undefined,
): string | null {
  if (!dockHours) return null;
  for (const entry of dockHours) {
    if (entry.opens >= entry.closes) {
      return `Invalid dock hours for ${entry.day}: opening time (${entry.opens}) must be before closing time (${entry.closes})`;
    }
  }
  return null;
}
